import ListItems from "./ListarInfo";

function Comorbidades() {
  return ListItems("comorb", []);
}
export default Comorbidades;
